import { render, staticRenderFns } from "./OListAdd.vue?vue&type=template&id=77523e5c"
import script from "./OListAdd.vue?vue&type=script&lang=js"
export * from "./OListAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports